import type { IconSvgObject } from './types';

const City01Icon: IconSvgObject = [
  ["path", { d: "M8 22V9C8 8.44772 8.44772 8 9 8H16C16.5523 8 17 8.44772 17 9V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 12.0018L13.5 12.0018M11.5 15.0009L13.5 15.0009M11.5 18.0018L13.5 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 21.9941V12.9941C3 12.4419 3.44772 11.9941 4 11.9941H8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M22 21.9883L2 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M13 7.97007V2L21 5.06137V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default City01Icon;
